import enviromentStore from '@/store/enviroment-data';
const { hasEditablePermission } = enviromentStore;

const localUserdataService = {};

export const setLocalUserdata = (router, dxTable, filters, dataSource) => {
  localUserdataService[router.currentRoute.value.name] = JSON.stringify({
    grid: dxTable.value.instance.state(),
    filters: filters || null,
    tableChanges: dxTable.value.instance.option('editing.changes'),
    dataSource
  });
}

export const getLocalUserdata = (router) => {
  const state = localUserdataService[router.currentRoute.value.name];
  return state && JSON.parse(state) || null;
}

export const initState = (router, dxTable, filters) => {
  const state = getLocalUserdata(router);
  if (state) {
    dxTable.value.instance.state(state.grid);
    if (filters)
      filters.value = state.filters;

    if (state.tableChanges)
      dxTable.value.instance.option('editing.changes', state.tableChanges);
  }

  return state;
}

export const hasEditablePermissionByUIRoute = (router) => {
  return hasEditablePermission(router);
}
